import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode><App /></React.StrictMode>
);

/* Phone card view for list tables (see "PHONE: APP FEEL" in index.css):
   every cell of a table.m-cards gets its column header as data-label,
   which the card layout prints in front of the value. Done once here
   for every page instead of in each table.

   Three more marks are put on each cell so the card can look like an app
   screen rather than a printed table:

     data-empty    the cell has nothing in it ("", "—", "-"). On a phone it
                   is hidden — "PHONE —" and "CITY —" lines were taking up
                   half the card and pushing the useful figure out of sight.
     data-actions  the cell holds only buttons. It becomes a button strip at
                   the bottom of the card, each button big enough for a thumb.
     data-strong   the cell is the money of the row (Balance / Due / Amount /
                   Total). It is printed big, so the eye lands on it first. */
var EMPTY_RE = /^(|-|—|–|n\/a|na)$/i;
var STRONG_RE = /balance|due|amount|total|outstanding|paid|bakaya/i;

function labelCardTables() {
  document.querySelectorAll('table.m-cards').forEach(function (tbl) {
    var heads = Array.prototype.map.call(tbl.querySelectorAll('thead th'), function (th) {
      return (th.textContent || '').trim();
    });
    tbl.querySelectorAll('tbody tr').forEach(function (tr) {
      Array.prototype.forEach.call(tr.children, function (td, i) {
        var label = heads[i] || '';
        if (td.getAttribute('data-label') !== label) td.setAttribute('data-label', label);

        var txt = (td.textContent || '').trim();
        var onlyButtons = td.children.length > 0 &&
          Array.prototype.every.call(td.children, function (c) {
            return c.tagName === 'BUTTON' || c.tagName === 'A' ||
              (c.children.length > 0 && Array.prototype.every.call(c.children, function (g) {
                return g.tagName === 'BUTTON' || g.tagName === 'A';
              }));
          });

        set(td, 'data-actions', onlyButtons ? '1' : null);
        /* a button cell is never "empty", even when the buttons have only icons */
        set(td, 'data-empty', (!onlyButtons && EMPTY_RE.test(txt)) ? '1' : null);
        set(td, 'data-strong', (!onlyButtons && i > 0 && STRONG_RE.test(label)) ? '1' : null);
      });
    });
  });
}
function set(el, attr, val) {
  if (val === null) { if (el.hasAttribute(attr)) el.removeAttribute(attr); }
  else if (el.getAttribute(attr) !== val) el.setAttribute(attr, val);
}
var labelTimer = null;
new MutationObserver(function () {
  if (labelTimer) return;
  labelTimer = setTimeout(function () { labelTimer = null; labelCardTables(); }, 80);
}).observe(document.getElementById('root'), { childList: true, subtree: true });
